import { render } from "./PaymentDetailsLanding.vue?vue&type=template&id=744aace9&scoped=true"
import script from "./PaymentDetailsLanding.vue?vue&type=script&lang=js"
export * from "./PaymentDetailsLanding.vue?vue&type=script&lang=js"

import "./PaymentDetailsLanding.vue?vue&type=style&index=0&id=744aace9&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-744aace9"]])

export default __exports__